import React from 'react';
import { Link } from 'react-router-dom';
import './ProgramPage.css';

const DataAnalytics = () => {
  return (
    <div className="program-page">
      <section className="program-hero program-hero--red">
        <div className="container">
          <h1>Online Data Analytics Course with Live Classes and Real Projects</h1>
          <p className="hero-description">
            Our data analytics course is designed for freshers and working professionals who want to build strong analytical skills using SQL, Python, Power BI, and business analytics concepts.
          </p>
        </div>
      </section>

      <section className="program-details section">
        <div className="container">
          <h2 className="section-title">Key Details</h2>
          <div className="details-grid">
            <div className="detail-card">
              <div className="detail-icon">⏱️</div>
              <h3>Duration</h3>
              <p>4 Months</p>
            </div>
            <div className="detail-card">
              <div className="detail-icon">🌐</div>
              <h3>Mode</h3>
              <p>Live Online</p>
            </div>
            <div className="detail-card">
              <div className="detail-icon">📅</div>
              <h3>Schedule</h3>
              <p>Weekday evenings + weekend sessions</p>
            </div>
            <div className="detail-card">
              <div className="detail-icon">🛠️</div>
              <h3>Tools</h3>
              <p>Excel, SQL, Python, Power BI</p>
            </div>
          </div>
        </div>
      </section>

      <section className="program-content section" style={{ backgroundColor: '#F5F5F5' }}>
        <div className="container">
          <h2 className="section-title">What You Will Learn</h2>
          <div className="learning-grid">
            <div className="learning-item">
              <div className="learning-icon">📊</div>
              <h3>Analytics Fundamentals</h3>
              <p>Core concepts of data analytics and business intelligence</p>
            </div>
            <div className="learning-item">
              <div className="learning-icon">💾</div>
              <h3>SQL for Data Analysis</h3>
              <p>Query databases, extract insights, and analyze data efficiently</p>
            </div>
            <div className="learning-item">
              <div className="learning-icon">🐍</div>
              <h3>Python for Analytics</h3>
              <p>Data manipulation, analysis, and visualization with Python</p>
            </div>
            <div className="learning-item">
              <div className="learning-icon">📈</div>
              <h3>Data Visualization</h3>
              <p>Create compelling visualizations and dashboards</p>
            </div>
            <div className="learning-item">
              <div className="learning-icon">📉</div>
              <h3>Business KPIs</h3>
              <p>Understand and track key performance indicators</p>
            </div>
            <div className="learning-item">
              <div className="learning-icon">📐</div>
              <h3>Statistics for Analytics</h3>
              <p>Statistical methods for data-driven decision making</p>
            </div>
          </div>
        </div>
      </section>

      <section className="program-cta section">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Start Your Data Analytics Journey?</h2>
            <p>Join our upcoming batch and learn from industry practitioners</p>
            <Link to="/academy/apply" className="btn btn-primary btn-large">
              Apply for Data Analytics Program
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default DataAnalytics;
